(function() {
  'use strict';

  var addAgentSelectedOfferToCart = function(
    uteLocale,
    $rootScope,
    $state,
    cartManager,
    $window,
    buyService,
    internetPackages
  ) {
    try {
      var lang = uteLocale.language;
      var agentInfo = $window.sessionStorage.getItem('agentSelectedOffer')
        ? JSON.parse($window.sessionStorage.getItem('agentSelectedOffer'))
        : { tierId: null, offerInContext: null };

      var abortAndGoToHsi = function() {
        buyService.deleteCheckoutSession();
        $state.go('internet');
      };

      if (agentInfo.tierId && agentInfo.offerInContext) {
        var pkgs = internetPackages[lang];

        var tierIndex = pkgs.tier.findIndex(function(tier) {
          return tier.tierId === agentInfo.tierId;
        });

        var offerIndex = pkgs.tier[tierIndex].products[0].offers.findIndex(function(offer) {
          return offer.offerId === agentInfo.offerInContext;
        });

        if (tierIndex > -1 && offerIndex > -1) {
          var tierInCart = cartManager.internet.tierInCart();
          if (!tierInCart || (tierInCart && tierInCart.tierId !== agentInfo.tierId)) {
            cartManager.internet.addOffer(pkgs.tier[tierIndex], agentInfo.offerInContext);
          }
        } else {
          abortAndGoToHsi();
        }
      } else {
        abortAndGoToHsi();
      }
      return;
    } catch (e) {
      return;
    }
  };

  angular.module('eclipseApp.checkout').config([
    '$stateProvider',
    function($stateProvider) {
      $stateProvider
        .state('cartSummary', {
          url: '/cart-summary',
          parent: 'app',
          title: 'cartSummary',
          views: {
            content: {
              templateUrl: 'modules/checkout/views/cart-summary.html',
              controller: 'cartCtrl'
            }
          },
          onEnter: [
            'maintenanceService',
            function(maintenanceService) {
              maintenanceService.getMaintenance('NAC');
            }
          ]
        })
        .state('buy', {
          url: '/buy',
          parent: 'app',
          title: 'buy',
          data: {
            functionality: 'limited'
            // authRequired: true // CR141
          },
          views: {
            content: {
              templateUrl: 'modules/checkout/views/buy.html',
              controller: 'buyCtrl'
            }
          },
          onEnter: [
            'uteLocale',
            '$rootScope',
            '$state',
            'cartManager',
            '$window',
            'buyService',
            'internetPackages',
            'brtSwitchCMS',
            function(uteLocale, $rootScope, $state, cartManager, $window, buyService, internetPackages, brtSwitchCMS) {
              if (brtSwitchCMS.brtSwitch.isHybridFlow && $rootScope.ruiMethods.user.is.agent()) {
                addAgentSelectedOfferToCart(
                  uteLocale,
                  $rootScope,
                  $state,
                  cartManager,
                  $window,
                  buyService,
                  internetPackages
                );
              }
              return;
            }
          ],
          resolve: {
            internetPackages: [
              'internetPackageService',
              'brtEndpoint',
              'brtSwitchCMS',
              '$q',
              'uteLocale',
              '$rootScope',
              '$window',
              'buyService',
              '$state',
              function(
                internetPackageService,
                brtEndpoint,
                brtSwitchCMS,
                $q,
                uteLocale,
                $rootScope,
                $window,
                buyService,
                $state
              ) {
                var deferred = $q.defer();

                var rejectPromiseAndExitBuy = function() {
                  $window.sessionStorage.setItem('agentSelectedOffer', '{}');
                  if (buyService.getSession('profile')) {
                    buyService.cleanSessions();
                  }
                  $state.go('internet');
                  buyService.resetStep('createUser');
                  deferred.reject();
                  return;
                };

                brtSwitchCMS
                  .getBRTStatus()
                  .then(function(switchData) {
                    if (switchData.isHybridFlow && $rootScope.ruiMethods.user.is.agent()) {
                      var params = {};
                      var lang = uteLocale.language;

                      params.province = uteLocale.province;
                      params.userId = $rootScope.atg && $rootScope.atg.userId && $rootScope.atg.userId.value;
                      params.hashKey = $rootScope.atg && $rootScope.atg.hashKey && $rootScope.atg.hashKey.value;
                      params.samKey = switchData.fetchAddressBasedOffers ? self.samKey : 'default';
                      internetPackageService
                        .getInternetPackage(brtEndpoint('v2/internetOffers'), params)
                        .then(function(response) {
                          deferred.resolve(response.data.internetPackages);
                        })
                        .catch(rejectPromiseAndExitBuy);
                    } else {
                      deferred.resolve({});
                    }
                  })
                  .catch(rejectPromiseAndExitBuy);

                return deferred.promise;
              }
            ]
          }
        })
        .state('createUser', {
          url: '/create-user',
          parent: 'buy',
          title: 'createUser',
          views: {
            'sub-content': {
              templateUrl: 'modules/checkout/views/buy-create-user.html',
              controller: 'buyCreateUserCtrl'
            }
          },
          onEnter: [
            'maintenanceService',
            '$rootScope',
            '$state',
            function(maintenanceService, $rootScope, $state) {
              maintenanceService.getMaintenance('NAC');
              if (
                !($rootScope.ruiMethods.user.is.loggedIn() || $rootScope.ruiMethods.user.is.agent()) &&
                ($rootScope.userPref.cartQuantity <= 0 ||
                  ($rootScope.userPref && $rootScope.userPref.samKey == 'default'))
              ) {
                $state.go('internet');
              }
            }
          ]
        })
        .state('creditCheck', {
          url: '/credit-check',
          parent: 'buy',
          title: 'creditCheck',
          views: {
            'sub-content': {
              templateUrl: 'modules/checkout/views/buy-credit-check.html',
              controller: 'buyCreditCheckCtrl'
            }
          },
          onEnter: [
            'maintenanceService',
            '$rootScope',
            '$state',
            function(maintenanceService, $rootScope, $state) {
              maintenanceService.getMaintenance('NAC');
              if (
                !($rootScope.ruiMethods.user.is.loggedIn() || $rootScope.ruiMethods.user.is.agent()) &&
                ($rootScope.userPref.cartQuantity <= 0 ||
                  ($rootScope.userPref && $rootScope.userPref.samKey == 'default'))
              ) {
                $state.go('internet');
              }
            }
          ]
        })
        .state('fulfillment', {
          url: '/fulfillment',
          parent: 'buy',
          title: 'fulfillment',
          resolve: {
            fulfillmentOptions: [
              'buyService',
              function(buyService) {
                return buyService.getSession('fulfillment');
              }
            ]
          },
          views: {
            'sub-content': {
              templateUrl: 'modules/checkout/views/buy-fulfillment.html',
              controller: 'buyFulfillmentCtrl'
            }
          },
          onEnter: [
            '$state',
            '$timeout',
            'buyService',
            '$rootScope',
            function($state, $timeout, buyService, $rootScope) {
              // do not proceed to next state if fulfillment option is only techInstall => {techInstall=TN}
              if (
                !($rootScope.ruiMethods.user.is.loggedIn() || $rootScope.ruiMethods.user.is.agent()) &&
                ($rootScope.userPref.cartQuantity <= 0 ||
                  ($rootScope.userPref && $rootScope.userPref.samKey == 'default'))
              ) {
                $state.go('internet');
              }
              if (buyService.getFulfillmentType() === 1) {
                return;
              }

              // goto specific tab when comming back when checking out after change-of-package
              // used $timeout to apply state-change after digest

              $timeout(function() {
                if (buyService.hasSession() && angular.isDefined(buyService.isTypeOfFulfillmentSelected())) {
                  $state.go(buyService.isTypeOfFulfillmentSelected());
                }
              });
            }
          ]
        })
        ////////// FULLFILLMENT TABS - START ///////////
        .state('shipToAddress', {
          url: '/ship-to-address',
          parent: 'fulfillment',
          title: 'shipToAddress',
          templateUrl: 'modules/checkout/views/ship-to-address.html',
          controller: 'shipToAddressCtrl',
          onEnter: [
            'maintenanceService',
            function(maintenanceService) {
              maintenanceService.getMaintenance('NAC');
            }
          ]
        })
        .state('pickupAtStore', {
          url: '/pickup-at-store',
          parent: 'fulfillment',
          title: 'pickUpAtStore',
          templateUrl: 'modules/checkout/views/pickup-at-store.html',
          controller: 'pickupAtStoreCtrl',
          onEnter: [
            'maintenanceService',
            function(maintenanceService) {
              maintenanceService.getMaintenance('NAC');
            }
          ]
        })
        .state('takeItWithYou', {
          url: '/take-it-with-you',
          parent: 'fulfillment',
          title: 'takeItWithYou',
          templateUrl: 'modules/checkout/views/take-it-with-you.html',
          controller: 'takeItWithYouCtrl'
        })
        .state('techInstall', {
          url: '/tech-install',
          parent: 'fulfillment',
          title: 'techInstall',
          templateUrl: 'modules/checkout/views/tech-install.html',
          controller: 'techInstallCtrl',
          onEnter: [
            'maintenanceService',
            function(maintenanceService) {
              maintenanceService.getMaintenance('NAC');
            }
          ]
        })
        .state('paymentOptions', {
          url: '/payment-options',
          parent: 'buy',
          title: 'paymentOptions',
          resolve: {
            paymentOptionsCreds: [
              '$http',
              'uteEndpoint',
              function($http, uteEndpoint) {
                return true;
                // return $http.post(uteEndpoint('/retrieveBillingEntity'));
              }
            ]
          },
          onEnter: [
            'buyService',
            'maintenanceService',
            '$rootScope',
            '$state',
            function(buyService, maintenanceService, $rootScope, $state) {
              var _session;
              maintenanceService.getMaintenance('NAC');
              if (
                !($rootScope.ruiMethods.user.is.loggedIn() || $rootScope.ruiMethods.user.is.agent()) &&
                ($rootScope.userPref.cartQuantity <= 0 ||
                  ($rootScope.userPref && $rootScope.userPref.samKey == 'default'))
              ) {
                $state.go('internet');
              }

              /*
               * @if:ROOT
               * handle setting edit-mode when user navigates back to payment-options from review page
               */
              if (buyService.hasSession()) {
                _session = buyService.getSession('profile');
                if (_session && _session.paymentOptions.submitted) {
                  buyService.setCheckoutMode(true);
                }
              }
            }
          ],
          views: {
            'sub-content': {
              templateUrl: 'modules/checkout/views/payment-options.html',
              controller: 'buyPaymentOptionsCtrl'
            }
          }
        })
        .state('review', {
          url: '/review',
          parent: 'buy',
          title: 'review',
          resolve: {
            orderSummary: [
              'notifier',
              'uteLocale',
              '$rootScope',
              '$state',
              'cartManager',
              '$window',
              'buyService',
              'internetPackages',
              'brtSwitchCMS',
              function(
                notifier,
                uteLocale,
                $rootScope,
                $state,
                cartManager,
                $window,
                buyService,
                internetPackages,
                brtSwitchCMS
              ) {
                try {
                  var session = sessionStorage.getItem('profile');
                  var data = angular.fromJson(session);
                  if (!session) {
                    notifier.notify.error();
                    return;
                  }

                  if (brtSwitchCMS.brtSwitch.isHybridFlow && $rootScope.ruiMethods.user.is.agent()) {
                    addAgentSelectedOfferToCart(
                      uteLocale,
                      $rootScope,
                      $state,
                      cartManager,
                      $window,
                      buyService,
                      internetPackages
                    );
                    var curatedOrderSummary = cartManager.internet.getCartSummary(
                      data.fulfillment.selectedOption === 'techInstall'
                    );

                    return curatedOrderSummary;
                  }
                  return data.review.data;
                } catch (e) {
                  console.error(e);
                  return;
                }
              }
            ]
          },
          views: {
            'sub-content': {
              templateUrl: 'modules/checkout/views/review.html',
              controller: 'buyReviewCtrl'
            }
          },
          onEnter: [
            'maintenanceService',
            '$rootScope',
            '$state',
            function(maintenanceService, $rootScope, $state) {
              maintenanceService.getMaintenance('NAC');
              if (
                !($rootScope.ruiMethods.user.is.loggedIn() || $rootScope.ruiMethods.user.is.agent()) &&
                ($rootScope.userPref.cartQuantity <= 0 ||
                  ($rootScope.userPref && $rootScope.userPref.samKey == 'default'))
              ) {
                $state.go('internet');
              }
            }
          ]
        })
        .state('confirmation', {
          url: '/confirmation',
          parent: 'buy',
          title: 'confirmation',
          data: {
            /*
             *  added because the visible functionality shouldn't
             *  be limited for this child state
             */
            functionality: '',
            showSubHeading: true
          },
          resolve: {
            order: [
              'uteLocale',
              '$rootScope',
              '$state',
              'cartManager',
              '$window',
              'buyService',
              'internetPackages',
              'brtSwitchCMS',
              function(
                uteLocale,
                $rootScope,
                $state,
                cartManager,
                $window,
                buyService,
                internetPackages,
                brtSwitchCMS
              ) {
                var session = buyService.getSession('confirmation');
                var profileSession = sessionStorage.getItem('profile');
                var profileData = angular.fromJson(profileSession);

                if (!session) {
                  return;
                } else {
                  if (brtSwitchCMS.brtSwitch.isHybridFlow && $rootScope.ruiMethods.user.is.agent()) {
                    addAgentSelectedOfferToCart(
                      uteLocale,
                      $rootScope,
                      $state,
                      cartManager,
                      $window,
                      buyService,
                      internetPackages
                    );
                    var curatedOrderSummary = cartManager.internet.getCartSummary(
                      profileData.fulfillment.selectedOption === 'techInstall'
                    );

                    console.log('sessssssh', session);

                    angular.extend(
                      session,
                      { orderSummaryData: curatedOrderSummary },
                      {
                        equipmentDetails: { serialNumber: session && session.serialNumber ? session.serialNumber : '' }
                      },
                      {
                        techInstall:
                          profileData.fulfillment.selectedOption === 'techInstall'
                            ? {
                                preferredTime: session.preferredTime ? session.preferredTime : '',
                                preferredPhone: session.phoneNoForTech ? session.phoneNoForTech : '',
                                appointDate: session.appointDate ? session.appointDate : '',
                                appointTime: session.appointTime ? session.appointTime : '',
                                notesForTech: session.notesForTech ? session.notesForTech : ''
                              }
                            : null
                      },
                      {
                        productDetails: {
                          productDesc: session.productDesc ? session.productDesc : '',
                          campaignCode: session.campaignCode ? session.campaignCode : '',
                          fulfilCampaign: session.fulfilCampaign ? session.fulfilCampaign : ''
                        }
                      },
                      {
                        paymentMethod: session.paymentMethod ? session.paymentMethod : '',
                        billingMethod: session.billingMethod ? session.billingMethod : ''
                      },
                      {
                        serviceReqDate: session.serviceReqDate ? session.serviceReqDate : '',
                        fulfilType: session.fulfilType ? session.fulfilType : '',
                        fulfilOption: session.fulfilOption ? session.fulfilOption : '',
                        maestroId: session.maestroId ? session.maestroId : ''
                      }
                    );
                  }
                  return session;
                }
              }
            ]
          },
          views: {
            'sub-content': {
              templateUrl: 'modules/checkout/views/confirmation.html',
              controller: 'buyConfirmationCtrl'
            }
          },
          onEnter: [
            'maintenanceService',
            function(maintenanceService) {
              maintenanceService.getMaintenance('NAC');
            }
          ]
        });
    }
  ]);
})();
